import React, { Component } from 'react';
import {
  BrowserRouter,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import {DatasetsAvailable} from './fetchData';
import Dataset from './Dataset';
import DatasetSelector from './DatasetSelector';
import {PageView, initGA} from './Tracking';

class App extends Component {

  constructor(props){
	super(props)
	this.state = {
		ViewObject: {},
		datasetDetails: [],
		FullProductPath: 'LongCovidDashboard',
		ProductName: 'Long Covid',
		datasetID: "",
		appURL: "",
		titleWindowData: {
		  showRecordView: false,
		  RecordNumbers: []
		},
		viewType: "",
	}
	
}

componentDidMount(){
	initGA('UA-5409011-1')
	PageView();
	let appURL = ""
	let datasetID = ""
	switch(this.state.ProductName){
		case "Sandbox":
			appURL = "https://patstat.org/VPWeb/VPWebServer.php"
			datasetID = 3
			break;
		case "Long Covid":
			appURL = "https://vpweb-cv1.thevantagepoint.com/VPWeb/VPWebServer.php"
			datasetID = 3
			break;
		default:
			appURL = "https://vpweb-cv1.thevantagepoint.com/VPWeb/VPWebServer.php"
			datasetID = 3
	}
	this.setState({
		appURL: appURL,
		datasetID: datasetID
	})
}
getAppDetails = (appURL, datasetID) => {
	this.setState({
		appURL: appURL,
		datasetID: datasetID
	})
}
resetApp = () => {
	if (this.state.ProductName === "Sandbox"){
		this.setState({
			appURL: "",
			datasetID: ""
		})
	}
}
  render() {
	const {
		datasetID,
		selectedSheetID,
		loading,
		FullProductPath,
		ProductName,
		appURL
	} = this.state;
	return (
	  <div>
		  <div className="App">
		  {(datasetID === "" || appURL === "") 
		  ?
			<DatasetSelector callbackFromParent={this.getAppDetails}></DatasetSelector>
		  :
		  <BrowserRouter basename={`/${FullProductPath}`}>

		  <Switch>
			  <Route path={'/'} render={props => <Dataset callbackFromParent={this.resetApp} appURL={appURL} FullProductPath={FullProductPath} ProductName={ProductName} datasetID={datasetID}/>}/>
			  <Route exact path={process.env.PUBLIC_URL + '/'} render={props => <Dataset callbackFromParent={this.resetApp} appURL={appURL} ProductName={ProductName} datasetID={datasetID}/>}/>
		  </Switch>
		  </BrowserRouter>
		  }
		  </div>
	  </div>
	);
  }
}

export default App;
